(function () {
  function initPictureCarousel(root) {
    if (!root || root.dataset.pictureCarouselInit === '1') return;
    root.dataset.pictureCarouselInit = '1';

    if (typeof Swiper === 'undefined') return;

    var nextEl = root.querySelector('.swiper-button-next');
    var prevEl = root.querySelector('.swiper-button-prev');

    new Swiper(root, {
      loop: true,
      centeredSlides: true,
      slidesPerView: 2.5,
      spaceBetween: 90,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        1000: {
          slidesPerView: 2.5,
          spaceBetween: 90,
        },
        590: {
          slidesPerView: 2.1,
          spaceBetween: 60,
        },
        320: {
          slidesPerView: 1.5,
          spaceBetween: 50,
        },
      },
    });
  }

  function initAll() {
    document.querySelectorAll('[data-picture-carousel]').forEach(initPictureCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-picture-carousel]').forEach(initPictureCarousel);
  });
})();
